"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.RoadblockModal = void 0;
var react_1 = __importDefault(require("react"));
var draft_illustration_1 = require("@kaizen/draft-illustration");
var typography_1 = require("@kaizen/typography");
var __1 = require("../");
var RoadblockModal_module_scss_1 = __importDefault(require("./RoadblockModal.module.scss"));
/**
 * @deprecated RoadblockModal is deprecated. Please use Confirmation Modal instead.
 */
var RoadblockModal = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, onDismiss = _a.onDismiss, onAfterLeave = _a.onAfterLeave, _b = _a.dismissLabel, dismissLabel = _b === void 0 ? "Back" : _b, automationId = _a.automationId, children = _a.children;
    return (react_1["default"].createElement(__1.GenericModal, { isOpen: isOpen, onEscapeKeyup: onDismiss, onOutsideModalClick: onDismiss, automationId: automationId, onAfterLeave: onAfterLeave },
        react_1["default"].createElement("div", { className: RoadblockModal_module_scss_1["default"].modal },
            react_1["default"].createElement(__1.ModalHeader, { unpadded: true, onDismiss: onDismiss },
                react_1["default"].createElement("div", { className: RoadblockModal_module_scss_1["default"].header },
                    react_1["default"].createElement("div", { className: RoadblockModal_module_scss_1["default"].headerBackground }),
                    react_1["default"].createElement("div", { className: RoadblockModal_module_scss_1["default"].iconContainer },
                        react_1["default"].createElement("div", { className: RoadblockModal_module_scss_1["default"].spotIcon },
                            react_1["default"].createElement(draft_illustration_1.Negative, { alt: "" }))),
                    react_1["default"].createElement(__1.ModalAccessibleLabel, null,
                        react_1["default"].createElement(typography_1.Heading, { tag: "h1", variant: "heading-1" }, title)))),
            react_1["default"].createElement(__1.ModalBody, null,
                react_1["default"].createElement("div", { className: RoadblockModal_module_scss_1["default"].body },
                    react_1["default"].createElement(__1.ModalAccessibleDescription, null, children))),
            react_1["default"].createElement(__1.ModalFooter, { actions: [{ label: dismissLabel, onClick: onDismiss }], appearance: "primary", automationId: automationId }))));
};
exports.RoadblockModal = RoadblockModal;
exports.RoadblockModal.displayName = "RoadblockModal";
//# sourceMappingURL=RoadblockModal.js.map